import { render, staticRenderFns } from "./ProgresoMecanizadoTab.vue?vue&type=template&id=220d00c8&"
import script from "./ProgresoMecanizadoTab.vue?vue&type=script&lang=js&"
export * from "./ProgresoMecanizadoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports